








































import Vue from "vue";
import { mapActions, mapGetters } from "vuex";
import iwModal from "@/shared/components/Modal.vue";

import iwNewCustomerForm from "@/encoding/pages/questions/contactinformations/NewCustomerForm.vue";

import { validateForm } from "@/shared/scripts/ValidateForm";

import iwButtonLoading from "@/shared/components/ButtonLoading.vue";

// Interfaces
import { Customer } from "@/shared/interfaces/customer/Customer.interface";
import { i18n } from "@/shared/scripts/helpers/translation/i18n";

export default Vue.extend({
    components: {
        iwModal: iwModal,
        iwNewCustomerForm: iwNewCustomerForm,
        iwButtonLoading: iwButtonLoading
    },

    props: {
        isVisible: {
            type: Boolean,
            required: true
        }
    },

    data: function() {
        return {
            isMobile: true as boolean,
            errors: null as unknown | Array<Record<string, unknown>>,
            isLoading: false,
        };
    },

    computed: {
        ...mapGetters({
            customerApiErrors: "CustomersModule/customerApiErrors",
            isMasquerading: "UserModule/isMasquerading",
        }),
        customer: function(): Customer|null {
            return this.$store.getters["FormModule/getValueUI"]("customer");
        },
        vatNumberError: function(): boolean {
            return this.$store.getters["FormModule/getValueUI"]("vatNumberError");
        }
    },

    mounted: function() {
        this.$store.commit("FormModule/deleteValueUI", "customer");
        this.$responsive.registerMediaQuery("from-desktop", () => {
            this.isMobile = false;
        }, () => {
            this.isMobile = true;
        });
    },

    methods: {
        ...mapActions("CustomersModule", ["createCustomer"]),

        closeModal: function() {
            this.$emit("closeModal");
        },
        createNewCustomer: function() {

            // Validate form

            const customerForm = document.getElementById("newCustomerForm") as HTMLFormElement;
            if (!customerForm) { return; }

            const isFormValid = validateForm(customerForm);

            if (!isFormValid.value === true || this.vatNumberError) {
                return this.$store.commit("CustomersModule/setCustomerFormError", isFormValid.errors);
            }

            this.$store.commit("CustomersModule/resetCustomerFormError");

            if (!this.customer) { return; }

            // Send request

            this.isLoading = true;
            this.customer.isNew = true;
            this.createCustomer(this.customer).then(success => {
                if (success) {
                    this.closeModal();
                }
            })
                .catch(() => this.dialog.alert(i18n.t("server_not_responding_error").toString()))
                .finally(() => this.isLoading = false);
        },
    }
});

